import type { Injector, Signal } from '@angular/core'
import { Injectable, inject } from '@angular/core'
import { EntitySignalQuery } from '@awork/core/state/signal-store/entitySignalQuery'
import type { ProjectTemplate } from '@awork/features/project/models/project-template.model'
import { ProjectTemplateStore } from '@awork/features/project/state/project-template.store'
import { Order } from '@awork/core/state/signal-store/types'
import type { Observable } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class ProjectTemplateQuery extends EntitySignalQuery<ProjectTemplate> {
  protected store: ProjectTemplateStore

  constructor() {
    const store = inject(ProjectTemplateStore)

    super(store)

    this.store = store
  }

  /**
   * Gets all project templates
   * @returns {Signal<ProjectTemplate[]>}
   */
  queryProjectTemplates(): Signal<ProjectTemplate[]> {
    return this.queryAll({
      sortBy: 'name',
      sortByOrder: Order.ASC
    })
  }

  /**
   * Gets a project template by id
   * @param {string} projectTemplateId
   * @returns {Signal<ProjectTemplate>}
   */
  queryProjectTemplate(projectTemplateId: string): Signal<ProjectTemplate> {
    return this.queryEntity(projectTemplateId)
  }

  /**
   * Selects a project template by id
   * @param {string} projectTemplateId
   * @param {Injector} injector
   * @returns {Observable<ProjectTemplate>}
   * @deprecated
   */
  selectProjectTemplate(projectTemplateId: string, injector: Injector): Observable<ProjectTemplate> {
    return this.selectEntity(projectTemplateId, injector)
  }
}
